import { useState } from 'react'
import { Icon } from '@iconify/react'
import { patch } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'
import Modal from '../../../../components/modal/Modal'
import FormLoader from '../../../../components/loader/FormLoader'
import { FLAG_LABELS } from './shared'
import '../customers/CustomerModals.scss'

interface Props {
  identityId: string
  code: string
  onClose: () => void
  onSuccess: () => void
}

const ClearFlagModal = ({ identityId, code, onClose, onSuccess }: Props) => {
  const { notify } = useGlobalContext()
  const [note, setNote] = useState('')
  const [loading, setLoading] = useState(false)

  const clear = () => {
    setLoading(true)
    patch(`admin/customer-identities/${identityId}/flags/${code}/clear`, {
      note: note.trim(),
    })
      .then((res: any) => {
        if (res.success) {
          notify('success', 'Flag cleared')
          onClose()
          onSuccess()
        } else notify('error', res.message)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }

  return (
    <Modal position='center'>
      <div className='customer-modal'>
        <div className='modal-header'>
          <div className='modal-icon icon-green'>
            <Icon icon='mdi:flag-remove-outline' />
          </div>
          <h2>Clear Flag</h2>
          <p>
            <b>{FLAG_LABELS[code] || code}</b>. Record what you checked — it is
            kept in the audit log.
          </p>
        </div>

        <div className='form-group'>
          <label>Note</label>
          <textarea
            rows={3}
            placeholder='e.g. Same shipper confirmed to use both resellers'
            value={note}
            onChange={(e) => setNote(e.target.value)}
            autoFocus
          />
        </div>

        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='modal-actions'>
            <button className='btn-cancel' onClick={onClose}>
              Cancel
            </button>
            <button
              className='btn-proceed'
              onClick={clear}
              disabled={note.trim().length < 5}
            >
              Clear flag
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default ClearFlagModal
